module.exports = require("dayjs/plugin/updateLocale");